import { SectionHeader, TextareaField, useScrollOnMount } from '@flos/react-ui';

const Comment = ({ label, value, setValue }: { label: string; value: string; setValue: (val: string) => void }) => {
  const scrollTarget = useScrollOnMount<HTMLDivElement>({ behavior: 'smooth' });

  return (
    <div className="u-Space-up" ref={scrollTarget}>
      <SectionHeader title={label} />
      {<TextareaField value={value} onChange={(evt) => setValue(evt.target.value)} maxLength={500} />}
    </div>
  );
};

export default Comment;
